import { useEffect, useContext } from 'react'
import { useSelector } from 'react-redux'

import {
  AmplitudeContext,
  AmplitudeProvider,
} from '@homebot/shared-util-quartermaster'

import { selectAuthedAsClient } from 'src/store/selectors/auth'
import {
  selectClientId,
  selectIsHomeowner,
  selectClientIsBuyer,
  selectClientIsGuest,
} from 'src/store/selectors/client'
import {
  selectCustomerIsRealEstateAgent,
  selectCustomerIsLoanOfficer,
  selectCustomerIsInsuranceAgent,
} from 'src/store/selectors/customerProfile'
import {
  selectCorporateProfileId,
  selectCustomerId,
} from 'src/store/selectors/customerProfile'
import { getBearerToken } from 'src/auth'

const amplitudeClientsDeploymentKey = process.env.REACT_APP_AMPLITUDE_DEPLOYMENT

export const AmpliProvider = ({ children }) => {
  const ampliContext = useContext(AmplitudeContext)

  const clientId = useSelector(selectClientId)
  const customerId = useSelector(selectCustomerId)
  const corpId = useSelector(selectCorporateProfileId)

  const isClient = useSelector(selectAuthedAsClient)
  const userScopeSelectors = {
    lo: useSelector(selectCustomerIsLoanOfficer) && !isClient,
    rea: useSelector(selectCustomerIsRealEstateAgent) && !isClient,
    ia: useSelector(selectCustomerIsInsuranceAgent) && !isClient,
    homeowner: useSelector(selectIsHomeowner) && isClient,
    buyer: useSelector(selectClientIsBuyer) && isClient,
    guest: useSelector(selectClientIsGuest) && isClient,
  }
  const scopes = Object.keys(userScopeSelectors).reduce((arr, key) => {
    if (userScopeSelectors[key]) {
      arr.push(key)
    }
    return arr
  }, new Array(0))

  useEffect(() => {
    ampliContext.setAmpliUserDetailFields({
      client_id: clientId,
      customer_id: customerId,
      corp_id: corpId,
      scopes,
    })
  }, [clientId, customerId, corpId, ampliContext, scopes])

  return (
    <AmplitudeProvider
      deploymentKey={amplitudeClientsDeploymentKey}
      token={getBearerToken()}
    >
      {children}
    </AmplitudeProvider>
  )
}
